module.exports = __webpack_public_path__ + "img/sql-server-icon-png.cb4f4af0.svg";